import './player.scss';
import React, { useEffect, useRef, useState } from 'react';
import videojs from 'video.js';
import videojsqualityselector from 'videojs-hls-quality-selector';
import { isPlatformBrowser, setTitle } from '../../shared/services/general/general-service';
import { useHistory } from 'react-router-dom';
import { Button, Icon } from '@material-ui/core';
import { sendAnalyticsEvent } from '../../shared/services/analytics/analytics-service';
import CloseIcon from '@material-ui/icons/Close';
import { useConfigApp } from '../../shared/services/general/app-context';
import { Helmet } from 'react-helmet';
require('videojs-contrib-ads');
require('videojs-ima');
require('videojs-contrib-quality-levels');
require('videojs-hls-quality-selector');
require('videojs-seek-buttons');

export default function PlayerComponent ({ data, id }) {
	let videoRef = useRef();
	const [player, setPlayer]                       = useState(null);
	const [playLink, setPlayLink]                       = useState(null);
	const [showSkipTitration, setShowSkipTitration] = useState(false);
	const history                                   = useHistory();
	const [value,setValue]							=useState(false)
	const [closeSubAlert,setCloseSubAlert]							=useState(false)
	const configApp = useConfigApp();

	useEffect(() => {
		setTitle('پخش برنامه‌ی ' + data?.title);
		const hideOtherElement = () => {
			if (isPlatformBrowser()) {
				let main_section = document.getElementsByClassName('main-section');
				let header       = document.getElementById('header');
				let navigator    = document.getElementById('navigator');
				if (main_section && main_section.length) {
					main_section.item(0).style.margin = 0;
				}
				if (header) {
					header.style.display = 'none';
				}
				if (navigator) {
					navigator.style.display = 'none';
				}
			}
		};
		hideOtherElement();
		initialPlayer();
		setPlayLink(data?.link);
	},[]);

	useEffect(() => {
		return () => {
			const showOtherElements = () => {
				if (isPlatformBrowser()) {
					let main_section = document.getElementsByClassName('main-section');
					let header       = document.getElementById('header');
					let navigator    = document.getElementById('navigator');
					if (main_section && main_section.length && window.innerWidth > 980) {
						main_section.item(0).style.marginTop = '70px';
					}
					if (header && window.innerWidth > 980) {
						header.style.display = 'flex';
					}
					if (navigator && window.innerWidth <= 980) {
						navigator.style.display = 'flex';
					}
				}
			};
			showOtherElements();
		};
	}, []);

	useEffect(() => {
		if (player) {
			if (playLink!=="" && configApp?.media_id){
				setPlayLink(playLink.replace(/mediaId=[^&]*/, `mediaId=${configApp.media_id}`));
			}
			player.src({
				src : playLink,
				autoplay: true,
				// type: 'application/x-mpegURL'
			});
		
			
			player.seekButtons({
				forward: 30,
				back   : 10
			});
			player.hlsQualitySelector = videojsqualityselector;
			player.hlsQualitySelector();
			customPlayerControlBar();
			sendAnalyticsEvent('watch', {
				id   : id,
				title: data?.title
			});

			const options = {
				// id: 'video-js-player',
				autoplay: true,
				adTagUrl: "https://api.mediaad.org/v1/bebin.com/vast/114112"
			};

			player.ima(options);

			player.ready(() => {
				player?.posterImage?.hide();
				player.on('loadedmetadata', () => {
					const posterElement = document.querySelector('.vjs-poster');
					if (posterElement) {
						posterElement.parentNode.removeChild(posterElement);
					}
				});

				player.on('adsready', () => {
					player.ima.initializeAdDisplayContainer();
					player.play();
				});

				player.on('adserror', (e) => {
					console.error("Ad Error:", e);
				});
			});
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [player]);

	useEffect(() => {
		if (player?.currentTime()) {
			setInterval(() => {
				setShowSkipTitration(player?.currentTime() > 10 && player?.currentTime() < 70);
			}, 1000);
		}
	}, [player]);

	const onHandleSubAlert = () => {
		setCloseSubAlert(true)
	};

	const renderSubscriptionAlert = () => {
		return (
			!closeSubAlert && (
				<div className="sub-alert">
					<Icon component={CloseIcon} onClick={onHandleSubAlert}/>
					<p>تعرفه ترافیک مصرفی شما به صورت  <strong> &nbsp;تمام بها</strong> محاسبه میشود</p>
				</div>
			)
		)
	}


	function initialPlayer () {
		const options = {
			aspectRatio          : '16:9',
			controls             : true,
			preload              : 'auto',
			// preload              : 'metadata',
			fluid                : false,
			autoplay             : 'play',
			poster: '',
			
				subtitles: {
					src: 'https://www.tutorialspoint.com/videos/captionsEng.vtt',
					kind: 'captions',
					srclang: 'en',
					label: 'English'
			},
			displayCurrentQuality: true,
			playbackRates        : [.25, .5, 1, 1.5, 2],
			html5                : {
				hls: {
					overrideNative: true
				}
			},
			hls                  : {
				withCredentials: true
			}
		};
		setPlayer(videojs(videoRef.current, options));
		videojs(videoRef.current).addClass('no-poster');
	}

	const customPlayerControlBar = () => {
		const renderVideoName = () => {
			const returnBtn = document.createElement('BUTTON');
			returnBtn.setAttribute('class', 'return-btn');
			returnBtn.addEventListener('click', () => {
				history.goBack();
			});
			document?.getElementsByClassName('vjs-custom-control-spacer')?.item(0)?.appendChild(returnBtn);
			document?.getElementsByClassName('vjs-custom-control-spacer')?.item(0)?.append(data?.title);
		};

		const renderSubtitle = (otherOperations) => {
			const changeSubtitleSrc = document?.getElementsByClassName('vjs-subs-caps-button vjs-control').item(0)
											  ?.getElementsByClassName('vjs-menu')?.item(0)?.children[ 0 ];
			// const title             = document?.createElement('LI');
			// title.appendChild(document?.createTextNode('زیرنویس'));
			// changeSubtitleSrc.insertBefore(title, changeSubtitleSrc?.firstChild);
			// otherOperations.appendChild(changeSubtitleSrc);
		};

		const renderAudio = (otherOperations) => {
			const changeAudioSrc = document.getElementsByClassName('vjs-audio-button vjs-control').item(0)
										   .getElementsByClassName('vjs-menu').item(0).children[ 0 ];
			const title          = document.createElement('LI');
			title.appendChild(document.createTextNode('صدا'));
			changeAudioSrc.insertBefore(title, changeAudioSrc.firstChild);
			otherOperations.appendChild(changeAudioSrc);
		};

		const renderOperations = () => {
			const otherOperations = document?.createElement('DIV');
			otherOperations.setAttribute('class', 'other-operations');
			renderSubtitle(otherOperations);
			renderAudio(otherOperations);
			const settingBtnMenu = document?.getElementsByClassName('vjs-menu-button vjs-menu-button-popup vjs-control vjs-button vjs-quality-selector')?.item(0)
										   ?.getElementsByClassName('vjs-menu')?.item(0);
			settingBtnMenu?.appendChild(otherOperations);
		};

		if (document && player) {
			renderVideoName();
			setTimeout(() => {
				renderOperations();
			}, 5000);
		}
	};

	// const handleSkipTitration = () => {
	// 	player.currentTime(70);
	// };

	return (
		<div className="main-container">
			{renderSubscriptionAlert()}
			{/* <video crossorigin="anonymous" id="video" ref={videoRef}
				   className="video-js vjs-big-play-centered vjs-big-play-button vjs-control vjs-seek-button vjs-default-button">
<source src="https://cdn.bebin.com/2022-10-10/1883/s01/e01/1883_s01e01_1080-480.mp4" type="video/mp4">
</source>

				<track kind="subtitles"
				 src="https://www.tutorialspoint.com/videos/captionsEng.vtt" 
				 srclang="en"
				  label="English" 
				  default></track>
			</video> */}
			<video
  class="video-js"
  ref={videoRef}
  id="video"
  rossorigin="anonymous"
  controls
  autoPlay
  playsInline
  preload="auto"
  width="640"
  height="264">
  <source src="//vjs.zencdn.net/v/oceans.mp4" type="video/mp4"/>
  {/*<track label="English" kind="subtitles" srclang="en" src="https://kot-politiken.s3-eu-west-1.amazonaws.com/2019/114_en.vtt.txt" default />*/}
			</video>
			{/*<Button*/}
			{/*	className={showSkipTitration ? 'skip-titration' : 'no-display-skip'}*/}
			{/*	onClick={() => handleSkipTitration()}*/}
			{/*	variant={'contained'}>*/}
			{/*	<span>رد کردن تیتراژ</span>*/}
			{/*</Button>*/}
			
			
		</div>
	);
}
